import React from "react";

const QCModal = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    // Overlay — click outside modal closes it
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{
        left: "var(--de-sidebar-offset, 272px)",
        background: "rgba(0,0,0,0.45)",
        backdropFilter: "blur(4px)",
        padding: "22px",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      {/* Modal box — clicks inside do not close */}
      <div
        className="relative w-[94%] max-w-[1400px] max-h-[90vh] flex flex-col overflow-hidden rounded-2xl shadow-2xl"
        style={{
          background: "#fff",
          border: "1px solid #e6eef4",
          fontFamily: "Poppins, sans-serif",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-5 py-3.5 flex-shrink-0"
          style={{
            background: "#032B4E",
            borderBottom: "1px solid #e6eef4",
          }}
        >
          <h2
            className="text-base font-semibold text-white m-0"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            Quality Check Dashboard
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="text-white hover:text-gray-200 text-2xl leading-none px-2"
            aria-label="Close quality check modal"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-3 md:p-4 overflow-y-auto flex-1" style={{ background: "#f6fafd" }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default QCModal;
